import { Node_Type } from '@wix/ricos';
import React from 'react';
export const htmlAttributesPlugin = (_)=>({
        config: {},
        type: '',
        nodeViewDecorators: [
            htmlAttributesDecorator
        ],
        nodeViewRenderers: {
            [Node_Type.EXTERNAL]: (__)=>/*#__PURE__*/ React.createElement(React.Fragment, null)
        }
    });
const htmlAttributesDecorator = {
    rule: (node)=>node.type === Node_Type.EXTERNAL,
    decorate: ({ node })=>{
        if (node.textData?.text == null) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
        const props = Object.fromEntries(Object.entries(node.externalData?.fields ?? []).map(([k, v])=>[
                k,
                v.stringValue
            ]));
        return /*#__PURE__*/ React.createElement("span", props, node.textData?.text);
    }
};

//# sourceMappingURL=ricos-html-attributes-plugin.js.map